import { LicenseType, SubscriptionStatusEnum, SubscriptionTierEnum } from "../../data-structures/enums";
import { Subscription } from "../../data-structures/interfaces";

export const getUserLicenseType = (subscription: Subscription) => {
    if (!subscription) {
        return LicenseType.Unassigned;
    }

    const status: string = subscription.status?.toLowerCase();

    if (status === SubscriptionStatusEnum.Suspended
        || status === SubscriptionStatusEnum.Completed
        || (status === SubscriptionStatusEnum.Canceled && (!subscription.expiryDate || new Date(subscription.expiryDate) < new Date()))
    ) {
        return LicenseType.Inactive;
    }

    if (subscription.expiryDate && new Date(subscription.expiryDate) < new Date()) {
        return LicenseType.Expired;
    }

    return subscription.tier === SubscriptionTierEnum.Trial
        ? LicenseType.Eval
        : LicenseType.Paid;
}